import React from 'react';
import { PropTypes } from 'prop-types';
import AsyncSelect from './AsyncSelect';
import UserService from '../../services/UserService';

class UserMultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.userSearch = this.userSearch.bind(this);
  }

  userSearch(input) {

    let params = { searchText: input, roles: this.props.roles || '' };

    return UserService.get(params)
      .then(data => {

        let result = data.items.map((item) => {
          return {
            id: item.id,
            firstName: item.attributes.firstName,
            lastName: item.attributes.lastName
          }
        });

        return { options: result || [] };
      });
  }

  valueRenderer(option) {
    return `${option.firstName} ${option.lastName}`;
  }

  render() {
    return (
      <AsyncSelect
        name={this.props.name}
        autoload={false}
        multi={true}
        valueKey="id"
        labelKey="firstName"
        valueRenderer={this.valueRenderer}
        optionRenderer={this.valueRenderer}
        onSearch={this.userSearch} />
    );
  }
}

UserMultiSelect.deafultProps = {
  roles:[]
};

UserMultiSelect.propTypes = {
  name: PropTypes.string.isRequired,
  roles: PropTypes.array
};

export default UserMultiSelect;



// WEBPACK FOOTER //
// ./src/components/form/UserMultiSelect.js